import React from "react";
import Checkbox from "src/scenes/EmployeeList/components/Checkbox";
import { Td, ButtonLabel, TdCenter } from "../style/Table.style";
import { ImageVideoCard } from "./ImageVideoCard";
import { TableRowCell } from "src/components/TableRowCell";
import { LottieLoadingIndicator, FlexContainer, portalColors } from "src/components";
import { isVideoThumbnail } from "../utils/VideoUtils";
import styled from "styled-components";
import { getVisibilityLabel } from "../../hooks/getVisibilityLabel";

const Card = styled.div`
    width: ${p => p.width || "83px"};
    height: ${p => p.height || "47px"};
    border: 1px solid ${portalColors.border};
    border-radius: ${p => p.borderRadius || "7px"};
    box-shadow: 0px 3px 6px #00000029;
    background: ${portalColors.surface};
    overflow: hidden;
`;

const WrappingCell = styled(Td)`
    width: ${p => p.$width || "200px"};
    white-space: normal !important;
    word-wrap: break-word;
    overflow-wrap: anywhere;
    overflow: visible;
    text-overflow: clip;
`;

const ContentLocationText = styled.span`
    display: block;
    line-height: 1.45;
    white-space: normal;
    word-break: normal;
    overflow-wrap: anywhere;
`;

export const Rows = ({ tableData, onToggle, isSelected, manageContent, getContentLocation }) => {
    const renderRow = (item, index) => (
        <tr key={index} className={isSelected(item.uuid) ? "selected" : ""}>
            <TdCenter paddingLeft="0" align="center">
                <label>
                    <Checkbox
                        readOnly
                        checked={isSelected(item.uuid)}
                        value={item.uuid}
                        onChange={() => onToggle(item)}
                    />
                </label>
            </TdCenter>
            <TdCenter>
                {item?.video?.pendingMedia && isVideoThumbnail(item?.video?.videoUrl) ? (  
                    <FlexContainer>
                        <Card>   
                            <div
                                style={{
                                    width: "83px",
                                    height: "47px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <LottieLoadingIndicator width="30px" height="30px" style={{ marginTop: "-23px" }} />
                            </div>
                        </Card>   
                    </FlexContainer>   
                ) : (
                    <ImageVideoCard
                        src={
                            item?.image !== null
                                ? item?.image?.imageUrl
                                : item?.video?.previewImageUrl
                        }
                        loading={!item}
                    />
                )}
            </TdCenter>
            <WrappingCell whiteSpace="normal" $width="200px">
                {item.title}
            </WrappingCell>

            <Td>
                <TableRowCell content={item?.description} clamp={4} padding={2} />
            </Td>
            <WrappingCell whiteSpace="normal" $width="220px">
                <ContentLocationText>{getContentLocation(item)}</ContentLocationText>
            </WrappingCell>
            <WrappingCell whiteSpace="normal" $width="200px">
                {getVisibilityLabel(item?.subcategory?.visibleTo ?? item?.visibleTo)}
            </WrappingCell>
            <TdCenter>
                <ButtonLabel
                    onClick={() => {
                        manageContent.toggleEditContentModal();
                        manageContent.setSelectedContent(item);
                    }}
                >
                    View/Edit
                </ButtonLabel>
            </TdCenter>
        </tr>
    );

    const renderEmpty = () => {
        const emptyRows = 10 - tableData.length;
        if (emptyRows < 1) return null;

        return Array.from({ length: emptyRows }, (_, i) => (
            <tr key={"empty_" + i}>
                {Array.from({ length: 7 }, (_, j) => (
                    <Td key={`empty_cell_${i}_${j}`} paddingLeft="0" align="center">
                        &nbsp;
                    </Td>
                ))}
            </tr>
        ));
    };

    return (
        <>
            {tableData.map(renderRow)}
            {renderEmpty()}
        </>
    );
};
